module.exports = __webpack_public_path__ + "media/images/emoticons/hairsalon-90c05a85bf9647f10e9577e8b3950ad3.gif";